import { withStyles } from '@material-ui/core';
import ActivityFeedItem from './ActivityFeedItem';
import styles from './styles';

export default withStyles(styles)(ActivityFeedItem);
